/* eslint-disable camelcase */
import { useSelector } from "react-redux";
import classNames from "classnames";
import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";

// Components
import Footer from "components/organisms/Footer";

// Containers
import HeaderContainer from "containers/organisms/HeaderContainer";

// Selectors
import * as authSelectors from "redux/auth/selectors";

import "./styles.sass";
import TabBarContainer from "../../../containers/molecules/TabBarContainer";

const CoinFestLayout = () => {
  const location = useLocation();
  const isAuthenticated = useSelector(authSelectors.isAuthenticated);

  useEffect(() => {
    window.scrollTo({
      top: -1,
      behavior: "smooth",
    });
  }, [location.pathname]);

  const headerClass = classNames("CoinFestLayout__header", {
    NewYearLayout__header_auth: isAuthenticated,
  });
  const containerClass = classNames("CoinFestLayout__container", {
    NewYearLayout__container_auth: isAuthenticated,
  });

  return (
    <div className="CoinFestLayout">
      <div className={containerClass}>
        <div className={headerClass}>
          <HeaderContainer />
        </div>
        <div className="CoinFestLayout__content">
          <div className="CoinFestLayout__content_container">
            <Outlet />
          </div>
        </div>
        <div className="CoinFestLayout__footer">
          <Footer />
        </div>
        <TabBarContainer />
      </div>
    </div>
  );
};

export default CoinFestLayout;
